import BriefPolicymakersSubnav from 'components/Dashboard/Influence/BriefPolicymakers/BriefPolicymakersSubnav';
import InfluenceCrmSideBar from 'components/Dashboard/Influence/InfluenceCrmSideBar/InfluenceCrmSideBar';
import React from 'react';
import { Outlet } from 'react-router';

const BriefPolicyMakersContainer = () => {
  return (
    <>
      <BriefPolicymakersSubnav />
      <div className={`row mx-auto main-content-wrapper pb-lg-0 flex-grow-1 content-lists-container`}>
        <div className={`side-left-element d-none d-lg-block`}>
          <div className='pl-lg-4'>
            <InfluenceCrmSideBar />
          </div>
        </div>

        <div className='flex-grow-1'>
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default BriefPolicyMakersContainer;
